/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoCloseTicketInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type TicketShowCloseMutationVariables = {
    input: infoCloseTicketInput;
};
export type TicketShowCloseMutationResponse = {
    readonly infoCloseTicket: {
        readonly clientMutationId: string | null;
    } | null;
};
export type TicketShowCloseMutation = {
    readonly response: TicketShowCloseMutationResponse;
    readonly variables: TicketShowCloseMutationVariables;
};



/*
mutation TicketShowCloseMutation(
  $input: infoCloseTicketInput!
) {
  infoCloseTicket(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoCloseTicketPayload",
    "kind": "LinkedField",
    "name": "infoCloseTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TicketShowCloseMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TicketShowCloseMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c7454aa57bbdfa83943d5239944e7490",
    "id": null,
    "metadata": {},
    "name": "TicketShowCloseMutation",
    "operationKind": "mutation",
    "text": "mutation TicketShowCloseMutation(\n  $input: infoCloseTicketInput!\n) {\n  infoCloseTicket(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'baa0267c9dbcfedc6da13a0cac7e6818';
export default node;
